<template>
  <!-- 审核页面 -->
  <div class='check'>
    <jsCheck v-if='type === 0' />
    <serverCheck v-else />
  </div>
</template>

<script>
import jsCheck from './jsCheck.vue'
import serverCheck from './serverCheck.vue'
import { mapGetters } from 'vuex'
import search from '@/libs/models'
import { workApi } from '@/api'
import cryptoPhp from '../../libs/common/cryptoPhp' // 加密解密文件
export default {
  data() {
    return {
      type: 0,
      userType: 1,
      merchantObj: Object.assign({}, search.merchantObj)
    };
  },
  activated () {
    this.init()
  },
  computed: {
    ...mapGetters(['user'])
  },
  created () {
    this.isUpdate = false
    this.userType = this.$route.query.userType
  },
  components: {
    serverCheck,
    jsCheck
  },
  // beforeRouteEnter (to, form, next) {
  //   if (form.path !== '/worker/checkResult') {
  //     let a = localStorage.getItem('id_user') ? JSON.parse(localStorage.getItem('id_user')) : {}
  //     if (a.identityList) {
  //       a.identityList.forEach(val => {
  //         if (val.userType - 0 === to.query.userType - 0) {
  //           if (val.auditStatus - 0 === 3) {
  //             next()
  //             return false
  //           } else if (val.auditStatus - 0 !== 2) {
  //             next({
  //               path: '/worker/checkResult',
  //               query: {
  //                 userType: to.query.userType
  //               }
  //             })
  //           } else {
  //             // next('/')
  //             let idUser = window.localStorage.id_user ? JSON.parse(window.localStorage.id_user) : {}
  //             let jrwyToken = cryptoPhp.Encrypt(idUser.jrwyToken)
  //             let backUrl = `${process.env.VUE_APP_AUTH_URL}/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`
  //             window.location.href = encodeURI(backUrl)
  //           }
  //         }
  //       });
  //       next()
  //     } else {
  //       next()
  //     }
  //   } else {
  //     next()
  //   }
  // },
  methods: {
    // 初始化
    init () {
      if (this.$route.query.userType - 0 === 2) {
        this.type = 0
      } else {
        this.type = 1
      }
    },
    // 家庭住址
    homeAddress(result) {
    },
    // 服务地址
    serviceAddress() {

    },
    // 商户注册
    // async addMerchant() {
    //   this.$loading()
    //   try {
    //     let params = this.merchantObj
    //     let data = (await workApi(params)).data
    //   } catch (err) {
    //   } finally {
    //     this.$loading().close()
    //   }
    // }
    async applymerchant() {
      this.$loading()
      try {
        let params = this.merchantObj
        let data = (await workApi(params)).data
        console.log(data)
      } catch (err) {
        console.log(err)
      } finally {
        this.$loading().close()
      }
    }
  }
};
</script>

<style scoped lang='less'>
@import "../../assets/styles/common.less";
</style>

